import { useState, useCallback } from 'react';
import { compareVeraScores } from '../utils/compareVeraScores';
import { FinancialHealthStats } from '../types/financialStats';

interface UseVeraScoreComparisonProps {
  baseline: FinancialHealthStats;
  calculatedStats: FinancialHealthStats;
}

export function useVeraScoreComparison({ baseline, calculatedStats }: UseVeraScoreComparisonProps) {
  const [isComparing, setIsComparing] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const compareScores = useCallback(async () => {
    setIsComparing(true);
    setError(null);
    try {
      const result = compareVeraScores(baseline, calculatedStats);
      if (import.meta.env.DEV) console.log('VeraScore Comparison Results:', result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to compare scores'));
      if (import.meta.env.DEV) console.error('Error comparing scores:', err);
    } finally {
      setIsComparing(false);
    }
  }, [baseline, calculatedStats]);

  return {
    compareScores,
    isComparing,
    error
  };
} 